import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/subscription',
}).lazy(() => import('./subscription.lazy').then((d) => d.Route))
